import { createRootSelector } from "../../../utils/createSelector.js";
export const gridRowsMetaSelector = createRootSelector(state => state.rowsMeta);